import React from "react";

import InstagramIcon from '../../assets/images/icon-instagram.webp'

interface Props {
  width?: any;
  maxWidth?: string;
  height?: any;
  className?: string;
}

const IconInstagram: React.FC<Props> = (props: Props) => {
  return (
    <span
      className={props.className}
      style={{
        width: props.width,
        maxWidth: props.maxWidth,
        height: props.height,
      }}
    >
      <img src={InstagramIcon} alt="Instagram" style={{ width: props.width, maxWidth: '100%' }} />
    </span>
  );
};

export default IconInstagram;
